// Bootstrap JS
// @devnote comment this line if you plan to
// use the CDN version of boostrap js
import { documentHasSelection } from '@wordpress/dom';
import 'bootstrap';

import * as webfontloader from 'webfontloader';
import { watchScroll } from './lib/scroll';
import { silenceModalsOnDismiss } from './lib/video';

/**
 * Benchmarking
 */
const timeStart = window.performance.now();

/**
 * Configure fonts for this project
 */
const webfonts = {
	google: {
		families: [
			'Open Sans:100,200,300,400,500,600,700,800,900',
			'Raleway:100,200,300,400,500,600,700,800,900',
			'Montserrat:300,500,600,700',
		],
	},
};

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Load Webfonts
	 */
	webfontloader.load(webfonts);

	// Do stuff...
	watchScroll();
	silenceModalsOnDismiss();

	/**
	 * Benchmarking reporting
	 */
	const timeEnd = window.performance.now();
	console.info(
		`Execution time: ${timeEnd - timeStart}ms after DOMContentLoaded.`
	);
});

/* Project-specific custom code */
window.addEventListener('load', () => {
	document.getElementById('navMenuToggle').addEventListener('click', () => {
		toggleMobileNav();
	});
	document.getElementById('closeMobileNavBtn').addEventListener('click', () => {
		toggleMobileNav();
	});
});

function toggleMobileNav() {
	document.getElementById("mobileNav").classList.toggle("showNav");
}

function navItemHover(id, index) {
	//alert(document.getElementById(id));
	//alert(index);
	document.getElementById(id).children[1].children[index].style.display = "block";
	
	for (let i = 0; i < document.getElementById(id).children[1].children.length; i++) {
		if (i == index) {
			document.getElementById(id).children[1].children[i].style.display = "block";
		} else {
			document.getElementById(id).children[1].children[i].style.display = "none";
		}
	}
}
window.navItemHover = navItemHover;